import { useEffect } from "react";
import { Box, Flex, Heading, HStack } from "@chakra-ui/react";
import { useQuery } from "@tanstack/react-query";
import { useSearchParams } from "react-router-dom";
import { TotalCountBadge } from "components/total-count-badge";
import { useLandlordSettingsProvider } from "contexts/landlord-settings-provider";
import {
  landlordPropertiesModel,
  landlordTenancyAgreementSummaryModel,
} from "modules/landlord-portal/models/overview";
import { LandlordBannerImage } from "modules/landlord-portal/screens/overview/components/banner-image/landlord-banner-image";
import { LandlordProperties } from "modules/landlord-portal/screens/overview/components/landlord-properties";

export function OverviewScreen() {
  const { ownershipId } = useLandlordSettingsProvider();
  const [searchParams, setSearchParams] = useSearchParams();

  const { data: propertyOwnerships, isLoading: isLoadingPropertyOwnerships } =
    useQuery(landlordPropertiesModel.queries.read(searchParams, ownershipId));

  const {
    data: tenancyAgreementSummary,
    isLoading: isLoadingTenancyAgreementSummary,
  } = useQuery(landlordTenancyAgreementSummaryModel.queries.read(ownershipId));

  /**
   * Resets the page when ownershipId is change
   */
  useEffect(() => {
    setSearchParams(
      (p) => {
        p.delete("page");
        return p;
      },
      { replace: true },
    );
  }, [ownershipId, setSearchParams]);

  return (
    <Box>
      <Flex direction={"column"} gap={8}>
        <LandlordBannerImage
          isLoading={isLoadingTenancyAgreementSummary}
          propertySummary={tenancyAgreementSummary}
        />
        <HStack gap={3}>
          <Heading fontSize={"xl"} as={"h2"}>
            My Portfolio
          </Heading>
          <TotalCountBadge count={propertyOwnerships?.pagination.total} />
        </HStack>
        <Box
          bg={"white"}
          borderRadius={"md"}
          overflow={"hidden"}
          borderWidth={1}
        >
          <LandlordProperties
            propertyOwnerships={propertyOwnerships}
            isLoadingPropertyOwnerships={isLoadingPropertyOwnerships}
            handleOnSetPage={(page) => {
              setSearchParams((p) => {
                p.set("page", String(page));
                return p;
              });
            }}
          />
        </Box>
      </Flex>
    </Box>
  );
}
